export default __webpack_public_path__ + "static/media/account-white.e6c3efe1.svg";